<template>
  <!--音频专辑添加  -->
  <div class="videoAdd">
    <div class="add_box">
      <el-form
        :model="AddList"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%;margin:20px auto; "
      >
        <el-row>
          <el-form-item label="选择作者" prop="authorId">
            <el-select placeholder="请选择" v-model="AddList.authorId">
              <el-option
                v-for="item in author"
                :key="item.id"
                :label="item.nickName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="标题" prop="title">
              <el-input placeholder="请输入内容" v-model="AddList.title" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="说明" prop="remark">
              <el-input
                type="textarea"
                :rows="10"
                placeholder="请输入内容"
                v-model="AddList.remark"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="上传视频" prop="ossUrl" ref="ossUrl">
            <el-upload
              :auto-upload="false"
              :before-upload="beforeUpload"
              :on-change="videoUp"
              :on-success="videoListSuccess"
              :show-file-list="false"
              action="https://jsonplaceholder.typicode.com/posts/"
              class="audio-upt"
              ref="uptImg"
            >
              <video :src="AddList.ossUrl" class="video" controls="controls" v-if="AddList.ossUrl"></video>
              <i
                :class="loadUpt ? 'el-icon-loading' : 'el-icon-plus avatar-uploader-icon'"
                style="marginTop:5px;font-size: 50px;"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button style="margin-left: 200px" type="primary" @click="submitAdd('ruleForm')" v-if="menuPerm('video:add')">保存</el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {baseURL} from '../../api/config'
export default {
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.AddList.ossUrl == "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: true, //上传删除
      loadUpt: false, //视频缓冲
    
      AudioUptImg: [], //图片上传
      //添加的参数：
      AddList: {
        authorId: "", //作者 id
        remark: "", //描述
        ossUrl: "", //封面图
        title: "" //标题
      },
      toAdRule: {
        authorId: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        remark: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        ossUrl: [{ required: true, validator: valiIcon, trigger: "blur" }]
      },

      author: "", //作者

      dialogImageUrl: "",
      dialogVisible: false
    };
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    //作者：
    getAuthor() {
      this.getAxios("/manager/list/userInfo", {
        managerId: localStorage.getItem("userId")
      }).then(res => {
        if (res.success == true) {
          this.author = res.content;
        } else if (!res.success && res.statusCode == "401") {
         this.$message.error(res.message);
         this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },
    //转base64
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    //上传图片限制
    beforeUpload(file, fileList) {
      return new Promise(resolve => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          img.src = e.target.result;
        };

        img.onload = function() {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;

          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            blob => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },
    // 视频上传
    videoUp(file, fileList) {
      if (file) {
        this.loadUpt = true;
        
        let files = file.raw;
      
        let formdata = new FormData();
        formdata.append("img", files);

        // var url=baseURL.host;
        // url+'/file/uploadFile'
        axios
          .post(baseURL + "/file/uploadFile", formdata, {})
          .then(res => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.AddList.ossUrl = res.entity; //接口url参数
              this.$refs.ossUrl.clearValidate();
              this.loadUpt = false;
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (
              !res.success &&
              res.statusCode == "401" 
            ) {
             this.$message.error(res.message);
             this.$router.push('/')
            }
          });
      }
    },

    //提交成功：
    videoListSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
    },
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/video/insert", {
            authorId: this.AddList.authorId, //作者 id

            remark: this.AddList.remark, //描述
            ossUrl: this.AddList.ossUrl, //封面图
            title: this.AddList.title //出品方
          }).then(res => {
            if (res.success == true) {
              this.$router.push({ path: "/video" });
              this.$message.success("添加成功！");
            } else if (res.success == false) {
            this.$message.error(res.message);
            } else if (
              !res.success && res.statusCode == "401"
            ) {
             this.$message.error(res.message);
             this.$router.push('/')
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  created() {
    this.getAuthor(); //作者

   
  }
};
</script>
<style scoped lang="less">
.videoAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 200px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 2px dashed #eee;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      img {
        width: 100%;
        height: auto;
      }
      video {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>